export default __webpack_public_path__ + "static/media/party-popper.ae002e21.png";